module.exports = __webpack_public_path__ + "static/media/close-black-24dp.01ecdf8e.svg";